// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';

import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Footer = styled.div({
	borderTop: `${token('color.border', '#ebedf0')} solid 2px`,
	paddingTop: token('space.050', '4px'),
	paddingBottom: token('space.050', '4px'),
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'center',
});
